module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyList":"No items to display (empty list)","page":"Page"},"fr":{"emptyList":"Aucun élément à afficher (liste vide)","page":"Page"}}')
  delete Component.options._Ctor
}
